import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "warning-block"
}
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["src"]

import { getIcon } from '@/helpers/api';
import { getFont } from '@/helpers/fonts';
import { StyleValue, computed, onBeforeMount, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorMsg',
  props: {
    msg: { type: [String, Array<string>], default: undefined },
    isInfo: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props

const errorIcon = ref<string>()
const nore10 = ref<StyleValue>()

onBeforeMount(async () => {
    nore10.value = await getFont('nore10') as StyleValue
    errorIcon.value = await getIcon("1120", "error_icon")
})

const getMessages = computed(() => Array.isArray(props.msg) ? props.msg : [props.msg])


return (_ctx: any,_cache: any) => {
  return (__props.msg !== undefined && __props.msg.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMessages.value, (m, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "text-block",
              key: key
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(["warning-text", { error: !__props.isInfo, info: __props.isInfo }]),
                style: _normalizeStyle(nore10.value)
              }, _toDisplayString(m), 7),
              (!__props.isInfo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: errorIcon.value
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})